export default "__VITE_ASSET__cddff408__"